import { UpdateOrderState } from '../type';

const returnOrderItem = (state: UpdateOrderState, id: string): UpdateOrderState => {
  const menuItem = state?.removedItems.filter((x) => x.id === id);
  if (menuItem) {
    return {
      ...state,
      updatedOrder: {
        ...state?.updatedOrder,
        orderItems: [...(state?.updatedOrder?.orderItems || []), ...(menuItem || [])],
      },
      removedItems: state?.removedItems?.filter((x) => x.id !== id),
    };
  }

  return state;
};

export default returnOrderItem;
